import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"
import store from "../../store"
import { SET_AUTH } from "../../store/auth/profile/actionTypes"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { checkBinId, checkId, checkWaverBarNumber, deleteBinAccount, deleteCarNumber, deleteDriverAccount, deleteWaverBarNumber, getBinList, getCarListAll, getMyProfile, getUserByToken, getWaverBarList, passwordChange, passwordReset, patchCompanyData, patchCompanyDetail, saveBinAccount, saveCarNumber, saveDriverAccount, saveWaverBarNumber, updateBinList, updateCarData, updateDriverAccount, updateWaverBarNumber } from "crud/auth.crud"
import { getDriverList } from "crud/search.crud";
import Util from "pages/Dashboard/Common/Util";

import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal_v2";
import coloredCorrespondent from "../../assets/images/svg/correspondent_color.svg"
import _ from "lodash";

// 주소 찾기
import DaumPostcode from 'react-daum-postcode';
import { getMyEmitterCompanyList } from "crud/contract.crud";

const initPasswordItem = {
  oldPassword: '',
  newPassword: '',
  passwordConfirm: '',
}

const WorkplaceManagementTreatment = () => {
  const selector = useSelector(state => state)
  const history = useHistory()
  const code = store.getState().Data?.code[0] || []
  const vehicles = code.filter(item => item.code === 'vehicles')
  const performances = code.filter(item => item.code === 'performances')
  const recycles = code.filter(item => item.code === 'recycles')
  const businessPartners = code.filter(item => item.code === 'businessPartners')

  const [vehicleItem, setVehicleItem] = useState({});
  const [performanceItem, setPerformanceItem] = useState({});
  const [recycleItem, setRecycleItem] = useState({});
  const [driverDataList, setDriverDataList] = useState([]);
  const [selectedDriverItem, setSelectedDriverItem] = useState({})
  const [carDataList, setCarDataList] = useState([]);
  const [selectedCarItem, setSelectedCarItem] = useState({})
  const [wasteBinDataList, setWasteBinDataList] = useState([]);
  const [selectedWasteBinItem, setSelectedWasteBinItem] = useState({})
  const [waverBarDataList, setWaverBarDataList] = useState([]);
  const [selectedWaverBarItem, setSelectedWaverBarItem] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const [workplaceItem, setWorkplaceItem] = useState({})
  const [passwordItem, setPasswordItem] = useState(initPasswordItem)
  const [driverItem, setDriverItem] = useState({})
  const [carItem, setCarItem] = useState({})
  const [wasteBinItem, setWasteBinItem] = useState({})
  const [waverBarItem, setWaverBarItem] = useState({})
  const [modalShow, setModalShow] = useState({
    post: false,
    workplace: false,
  })
  const [pages, setPages] = useState({
    driver: 1
  })
  const [contractedCompanyDataList, setContractedCompanyDataList] = useState([]);
  const [inputType, setInputType] = useState('')
  const profileData = selector.Profile?.auth?.[0] || selector.auth?.user || {};
  const companyData = profileData?.member_group?.[0]?.company_group || {}
  const companyDetailData = companyData?.company_detail?.[0] || {}

  useEffect(() => {
    setWorkplaceItem({
      id: companyData.id,
      companyName: companyData.name || '',
      businessNumber: companyData.company_number || '',
      representative: companyData.username || '',
      email: companyData.email || '',
      zipcode: companyData.zipCode || '',
      address1: companyData.address1 || '',
      address2: companyData.address2 || '',
      mobilePhone: companyData.mobile_phone || '',
      phone: companyData.phone || '',
      fax: companyData.fax || '',
      collectionSector: companyDetailData?.collection_sector || '',
      employee: companyDetailData?.employee || '',
      sector2: companyDetailData?.sector2 || '',
      capacity: companyDetailData.capacity || '',
      businessPartner: companyDetailData?.customer || '',
      facility: companyDetailData?.facility || '',
    })

    const localVehiclesData = companyDetailData.vehicle ? JSON.parse(companyDetailData.vehicle) : [];
    setVehicleItem(Object.assign({}, ...localVehiclesData))
    
    const localPerformancesData = companyDetailData.performance ? JSON.parse(companyDetailData.performance) : [];
    setPerformanceItem(Object.assign({}, ...localPerformancesData))
    
    const localRecyclesData = companyDetailData.recycle_performance ? JSON.parse(companyDetailData.recycle_performance) : [];
    setRecycleItem(Object.assign({}, ...localRecyclesData))
  }, [])

  const changeWorkplaceInfo = async () => {
    modalClose('workplace')
    if (isLoading)
      return
    setIsLoading(true)
    const companyParams = {
      name: workplaceItem.companyName || '',
      company_number: workplaceItem.businessNumber || '',
      username: workplaceItem.representative || '',
      email: workplaceItem.email || '',
      zipcode: workplaceItem.zipCode || '',
      address1: workplaceItem.address1 || '',
      address2: workplaceItem.address2 || '',
      mobile_phone: workplaceItem.mobilePhone || '',
      phone: workplaceItem.phone || '',
      fax: workplaceItem.fax || '',
    }
    const companyDetailParams = {
      collection_sector: workplaceItem.collectionSector || '',
      employee: workplaceItem.employee || '',
      sector2: workplaceItem.sector2 || '',
      capacity: workplaceItem.capacity || '',
      customer: workplaceItem.businessPartner || '',
      facility: workplaceItem.facility || ''
    }
    const companyRs = await patchCompanyData(companyData.id, companyParams)
    const companyDetailRs = await patchCompanyDetail(companyDetailData.id, companyDetailParams)
    if (companyRs?.status === 200 && companyDetailRs?.status === 200) {
      setIsLoading(false)
      alert('정상적으로 수정되었습니다.')
      const memberResponse = await getMyProfile(selector.auth?.user?.id);
      store.dispatch({ type: SET_AUTH, data: [memberResponse.data] });
    } else {
      setIsLoading(false)
      alert('수정에 실패하였습니다.')
    }
  }

  const changePassword = async () => {
    if (isLoading)
      return;
    if (passwordItem.newPassword !== passwordItem.passwordConfirm) {
      return alert('새 비밀번호와 비밀번호 확인이 같지 않습니다.')
    }
    setIsLoading(true)
    const params = {
      id: profileData['id'],
      old_password: passwordItem.oldPassword,
      password: passwordItem.newPassword,
    }
    const rs = await passwordChange(params)
    if (rs.data?.result === 'success') {
      setPasswordItem(initPasswordItem)
      modalClose('changePassword')
      setIsLoading(false)
      alert("비밀번호가 정상적으로 변경되었습니다.")
    } else {
      setIsLoading(false)
      alert(rs?.data?.msg || "비밀번호를 정확히 입력해주세요.")
    }
  }

  const changeInputCondition = (path, value, setter) => {
    setter(prev => {
      const keys = path.split(".");
      const newState = { ...prev };
      let curr = newState;

      for (let i = 0; i < keys.length - 1; i++) {
        const k = keys[i];
        curr[k] = { ...curr[k] };
        curr = curr[k];
      }

      curr[keys[keys.length - 1]] = value;
      return newState;
    });
  };

  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
  }

  const checkUserId = async (id, setter) => {
    if (!id || id.length === 0) {
      return alert('아이디를 입력해주세요.')
    }
    var reg = /^[A-Za-z\d]{3,15}$/
    if (!reg.test(id)) {
      return alert('3-15자의 영문/숫자 조합으로 아이디를 입력해주세요.')
    }
    const params = {
      user_id: id,
    }
    const rs = await checkId(params)
    if (rs.data?.result === 'success') {
      changeInputCondition('confirmedId', id, setter)
      alert('사용할 수 있는 아이디입니다.')
    } else {
      alert('사용중인 아이디입니다.')
    }
  }

  const resetPassword = async () => {
    if (!selectedDriverItem.id || isLoading)
      return
    if (confirm('비밀번호를 초기화하시겠습니까?')) {
      setIsLoading(true)
      const params = {
        id: selectedDriverItem.id,
      }
      const rs = await passwordReset(params)
      if (rs.data?.result === 'success') {
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
      alert(rs.data.msg)
    }
  }

  const getDriverDataList = async () => {
    setIsLoading(true)

    let params = {
      page: pages.driver,
      company: companyData.id
    }

    const response = await getDriverList(params);
    if (response.data.result === 'success') {
      const content = response.data?.data || [];
      setDriverDataList(content)
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }
  }

  const isPasswordValidated = (item) => {
    let passwordReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!passwordReg.test(item.password) || item.password === '') {
      alert("8자 이상의 영문/숫자 조합으로 비밀번호를 입력해주세요.")
      return false
    }
    if (item.password !== item.passwordConfirmed) {
      alert("비밀번호확인을 정확히 입력해주세요.")
      return false
    }
    return true
  }

  const isValidated = (item) => {
    let emailReg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (item.id === '') {
      alert("아이디를 입력해주세요.")
      return false
    }
    if (!item.confirmedId) {
      alert("아이디 중복확인을 해주세요.")
      return false
    }
    if (item.name === '') {
      alert("이름을 입력해주세요.")
      return false
    }
    if (!emailReg.test(item.email) || item.email === '') {
      alert("유효한 이메일을 입력해주세요.")
      return false
    }
    if (item.mobilePhone === '') {
      alert("휴대폰 번호를 입력해주세요.")
      return false
    }
    return true
  }

  const saveDriver = async () => {
    setIsLoading(true)
    if (!isValidated(driverItem) || !isPasswordValidated(driverItem)) {
      setIsLoading(false)
      return;
    }
    const params = {
      'user_id': driverItem.confirmedId || '',
      'password': driverItem.password || '',
      'username': driverItem.name || '',
      'email': driverItem.email || '',
      'mobile_phone': driverItem.mobilePhone || '',
      'type': 'driver',
      'push_token': '',
      'status': 'Y',
      'company_id': companyData.id
    }
    const rs = await saveDriverAccount(params)
    if (rs.data.result === 'success') {
      modalClose('registerDriver')
      setDriverItem({})
      getDriverDataList()
    }
    alert(rs.data?.msg)
    setIsLoading(false)
  }

  const changeDriver = async () => {
    setIsLoading(true)
    if (!isValidated(selectedDriverItem)) {
      setIsLoading(false)
      return;
    }
    const params = {
      'id': selectedDriverItem.id || '',
      'user_id': selectedDriverItem.confirmedId || '',
      'username': selectedDriverItem.name || '',
      'email': selectedDriverItem.email || '',
      'mobile_phone': selectedDriverItem.mobilePhone || '',
    }
    const rs = await updateDriverAccount(params)
    if (rs.data.result === 'success') {
      setIsLoading(false)
      setSelectedDriverItem({})
      getDriverDataList()
    } else {
      setIsLoading(false)
    }
    alert(rs.data?.msg)
  }

  const deleteDriver = async (item) => {
    if (confirm('운전자 계정을 삭제하시겠습니까?')) {
      setIsLoading(true)
      const params = {
        user_id: item.user_id + '_deleted_' + new Date().getTime(),
        email: item.email + '_deleted',
        mobile_phone: item.mobile_phone + '_deleted',
        status: 'N'
      }
      const rs = await deleteDriverAccount(params)
      if (rs.data.result === 'success') {
        getDriverDataList()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
      alert(rs.data?.msg)
    }
  }

  const getCarDataList = async () => {
    const response = await getCarListAll(companyData.id)
    if (response.data?.result === 'success') {
      setCarDataList(response.data?.data)
    }
  }

  const checkCarPk = async () => {
    if (carItem.number === '') {
      return alert("차량번호를 입력해주세요.")
    }
    setIsLoading(true)
    const params = {
      number: carItem.number,
    }
    const rs = await checkCarNumber(params)
    if (rs.data?.result === 'success') {
      changeInputCondition('confirmedNumber', e.target.value, setCarItem)
    }
    alert(rs.data?.msg)
    setIsLoading(false)
  }

  const isCarValidated = () => {
    if (carItem.number === '') {
      alert("차량번호를 입력해주세요.")
      return false
    } else if (carItem.confirmedNumber === false) {
      alert("차량번호 중복을 확인해주세요.")
      return false
    } else if (carItem.name === '') {
      alert("차량이름을 입력해주세요.")
      return false
    }
    return true
  }

  const saveCar = async () => {
    setIsLoading(true)
    if (!isCarValidated()) {
      setIsLoading(false)
      return;
    }
    const params = {
      'number': carItem.confirmedNumber,
      'name': carItem.name,
      'company': companyData.id,
      'status': 'Y',
    }
    const rs = await saveCarNumber(params)
    if (rs.status === 201) {
      setCarItem({})
      modalClose('registerCar')
      getCarDataList()
      alert('정상적으로 등록되었습니다.')
    } else {
      alert('등록에 실패했습니다.')
    }
    setIsLoading(false)
  }

  const changeCar = async () => {
    setIsLoading(true)
    const params = {
      'id': selectedCarItem.id || '',
      'number': selectedCarItem.number || '',
      'name': selectedCarItem.name || '',
    }
    const rs = await updateCarData(params)
    if (rs.data.result === 'success') {
      setIsLoading(false)
      setSelectedCarItem({})
      getCarDataList()
    } else {
      setIsLoading(false)
    }
    alert(rs.data?.msg)
  }

  const deleteCar = async (item) => {
    if (confirm('해당 차량정보를 삭제하시겠습니까?')) {
      setIsLoading(true)
      const params = {
        status: 'N'
      }
      const rs = await deleteCarNumber(params, item.id)
      if (rs.data.result === 'success') {
        getDriverDataList()
        setIsLoading(false)
        alert('정상적으로 삭제되었습니다.')
      } else {
        setIsLoading(false)
        alert('삭제에 실패하였습니다.')
      }
    }
  }

  const getWasteBinDataList = async () => {
    try {
      const params = {
        page: 1,
        company: companyData.id
      }
      const response = await getBinList(params);
      const content = response.data?.results || [];
      setWasteBinDataList(content)
    } catch (error) {
      console.error(error);
    }
  }

  const checkWasteBinPk = async () => {
    if (wasteBinItem.id === '') {
      return alert('RFID를 입력해주세요.')
    }
    setIsLoading(true)
    const params = {
      id: wasteBinItem.id,
    }
    const rs = await checkBinId(params)
    if (rs.data?.result === 'success') {
      changeInputCondition('confirmedId', wasteBinItem.id, setWasteBinItem)
    }
    alert(rs.data?.msg)
    setIsLoading(false)
  }

  const isWasteBinValidated = () => {
    if (wasteBinItem.id === '') {
      alert("RFID를 입력해주세요.")
      return false
    }
    if (!wasteBinItem.confirmedId) {
      alert("RFID 중복확인을 해주세요.")
      return false
    }
    if (wasteBinItem.mount === '') {
      alert("용량을 입력해주세요.")
      return false
    }
    if (_.isEmpty(wasteBinItem.company)) {
      alert("대상업체를 입력해주세요.")
      return false
    }
    return true
  }

  const saveWasteBin = async () => {
    setIsLoading(true)
    if (!isWasteBinValidated()) {
      setIsLoading(false)
      return;
    }
    const params = {
      'id': wasteBinItem.confirmedId,
      'mount': wasteBinItem.mount,
      'owner': wasteBinItem.company.id,
      'company': companyData.id,
      'status': 'Y',
    }
    const rs = await saveBinAccount(params)
    if (rs.status === 201) {
      modalClose('registerWastebin')
      setWasteBinItem({})
      getWasteBinDataList()
      alert('정상적으로 등록되었습니다.')
    } else {
      alert('등록에 실패하였습니다.')
    }
    setIsLoading(false)
  }

  const changeWasteBin = async () => {
    setIsLoading(true)
    const params = {
      mount: selectedWasteBinItem.mount,
      RFID: selectedWasteBinItem.id,
      owner: selectedWasteBinItem.new_owner_company_data.id || selectedWasteBinItem.owner_company_data.id
    }
    const rs = await updateBinList(params)
    if (rs.data.result === 'success') {
      setIsLoading(false)
      setSelectedWasteBinItem({})
      getWasteBinDataList()
    } else {
      setIsLoading(false)
    }
    alert(rs.data?.msg)
  }

  const deleteWasteBin = async (item) => {
    if (confirm('해당 쓰레기통을 삭제하시겠습니까?')) {
      setIsLoading(true)
      const params = {
        status: 'N'
      }
      const rs = await deleteBinAccount(params, item.id);
      if (rs?.status === 200) {
        setIsLoading(false)
        alert('정상적으로 삭제되었습니다.')
      } else {
        setIsLoading(false)
        alert('삭제에 실패하였습니다.')
      }
    }
  }

  const getWaverBarDataList = async () => {
    setIsLoading(true)

    let params = {
      page: 1,
      company: companyData.id
    }

    const response = await getWaverBarList(params);
    const content = response.data?.results || [];
    setWaverBarDataList([...content])
    setIsLoading(false)
  }

  const checkWaverBarPk = async () => {
    setIsLoading(true)
    if (!waverBarItem.id) {
      setIsLoading(false)
      return alert("웨버바 번호를 입력해주세요.")
    }
    const params = {
      id: waverBarItem.id,
    }
    const rs = await checkWaverBarNumber(params)
    if (rs.data?.result === 'success') {
      changeInputCondition('confirmedId', waverBarItem.id, setWaverBarItem)
    }
    alert(rs.data?.msg)
    setIsLoading(false)
  }

  const isWaverBarValidated = () => {
    setIsLoading(false)
    if (!waverBarItem.id) {
      alert("웨버바 번호를 입력해주세요.")
      return false
    } else if (!waverBarItem.confirmedId) {
      alert("웨버바 번호 중복 확인을 해주세요.")
      return false
    }
    return true
  }

  const saveWaverBar = async () => {
    setIsLoading(true)
    if (!isWaverBarValidated()) {
      setIsLoading(false)
      return;
    }
    const params = {
      'id': waverBarItem.confirmedId,
      'company': companyData.id,
      'car': waverBarItem.car,
      'status': 'Y',
    }
    const rs = await saveWaverBarNumber(params)
    if (rs.status === 201) {
      modalClose('registerWaverBar')
      getWaverBarDataList()
      setWaverBarItem({})
      alert('정상적으로 등록되었습니다.')
    } else {
      alert('등록에 실패했습니다.')
    }
    setIsLoading(false)
  }

  const changeWaverBar = async () => {
    setIsLoading(true)
    const params = {
      id: selectedWaverBarItem?.id,
      car: selectedWaverBarItem?.car_data?.id || ''
    }
    const rs = await updateWaverBarNumber(params, selectedWaverBarItem.oldId)
    modalClose('waverBar')
    if (rs.status === 200) {
      setIsLoading(false)
      setSelectedWaverBarItem({})
      getWaverBarDataList()
      alert('정상적으로 수정되었습니다.')
    } else {
      setIsLoading(false)
      alert('수정에 실패하였습니다.')
    }
  }

  const deleteWaverBar = async (item) => {
    if (confirm("해당 웨버바를 삭제하시겠습니까?")) {
      setIsLoading(true)
      {
        const params = {
          status: 'N'
        }
        const response = await deleteWaverBarNumber(params, item.id);
        if (response?.status === 200) {
          alert('정상적으로 삭제되었습니다.')
        }
      }
      setIsLoading(false)
      getWaverBarDataList()
    }
  }

  // 주소찾기 API
  const Post = () => {

    const complete = (data) => {
      // data.zonecode는 우편번호, data.roadAddress는 도로명주소
      let zipAddress = data.zonecode;
      let roadAddress = data.roadAddress;
      modalClose('post')

      changeInputCondition('zipCode', zipAddress)
      changeInputCondition('companyAddress1', roadAddress)
    }

    return (
      <div>
        <DaumPostcode
          className="postmodal"
          autoClose
          onComplete={complete} />
      </div>
    );
  };

  const getContractedCompanyDataList = async () => {
    const rs = await getMyEmitterCompanyList()
    setContractedCompanyDataList(rs?.data?.data || [])
  }

  useEffect(() => {
    getCarDataList()
    getDriverDataList()
    getWasteBinDataList()
    getWaverBarDataList()
    getContractedCompanyDataList()
  }, [])

  return (
    <React.Fragment>
      <div className="d-flex align-items-center margin-bottom-12">
        <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
        <p className="font-weight-bold font-size-15 mb-0 margin-left-6">사업자 정보</p>
      </div>
      <div className="d-flex w-100 gap-30 align-items-center mb-3">
        <div className="email-rightbar flex-grow-1">
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <tbody>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">상호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={workplaceItem.companyName || ''} onChange={(e) => {
                        changeInputCondition('companyName', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">사업자번호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자번호를 입력하세요." value={workplaceItem.companyNumber || ''} onChange={(e) => {
                        changeInputCondition('companyNumber', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">대표자명</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="대표자명을 입력하세요." value={workplaceItem.representative || ''} onChange={(e) => {
                        changeInputCondition('representative', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">이메일주소</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="이메일을 입력하세요." value={workplaceItem.email || ''} onChange={(e) => {
                        changeInputCondition('email', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text padding-right-8">사업장 주소</td>
                    <td colSpan="7">
                      <input className='waver-input-box w-8 border-radius-0 margin-right-4' value={workplaceItem.zipCode || ''} disabled placeholder="우편번호" />
                      <button type="button" className="custom-btn secondary-bg w-10 border-radius-0 white-text border-none margin-right-4" onClick={() => {
                        modalOpen('post')
                      }}>
                        주소 찾기
                      </button>
                      <input className='waver-input-box w-30 border-radius-0 margin-right-4' value={workplaceItem.address1 || ''} disabled placeholder="주소" />
                      <input className='waver-input-box w-30 border-radius-0' value={workplaceItem.address2} placeholder="상세 주소" onChange={(e) => {
                        changeInputCondition('address2', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">휴대폰 번호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={workplaceItem.mobilePhone || ''} onChange={(e) => {
                        changeInputCondition('mobilePhone', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">전화번호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자번호를 입력하세요." value={workplaceItem.phone || ''} onChange={(e) => {
                        changeInputCondition('phone', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">FAX 번호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={workplaceItem.fax || ''} onChange={(e) => {
                        changeInputCondition('fax', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">업종</td>
                    <td className="w-15">
                      <select className='waver-select-box w-100 border-radius-0' value={workplaceItem.collectionSector || ''} onChange={(e) => {
                        changeInputCondition('collectionSector', e.target.value, setWorkplaceItem)
                      }}>
                        <option value="" hidden>{'선택해 주세요'}</option>
                        <option value="life">{'생활계'}</option>
                        <option value="worklife">{'사업장 생활계'}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">ID</td>
                    <td className="w-15">{profileData.user_id}</td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">비밀번호</td>
                    <td className="w-15">
                      <button type="button" className="w-100 custom-btn border-radius-0 white-bg primary-text button-border" onClick={() => {
                        modalOpen('changePassword')
                      }}>
                        비밀번호 변경
                      </button>
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12"></td>
                    <td className="w-15"></td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12"></td>
                    <td className="w-15"></td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
      </div>

      <div className="d-flex align-items-center margin-bottom-12">
        <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
        <p className="font-weight-bold font-size-15 mb-0 margin-left-6">사업장 정보</p>
      </div>
      <div className="d-flex w-100 gap-30 align-items-center mb-3">
        <div className="email-rightbar flex-grow-1">
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <colgroup>
                  {Array.from({ length: 20 }).map((_, index) => (
                    <col key={'col_'+index} width={"5%"} />
                  ))}
                </colgroup>
                <tbody>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12" colSpan={2}>종업원수</td>
                    <td className="w-15" colSpan={3}>
                      <select className='waver-select-box w-100 border-radius-0' value={workplaceItem.employee || ''} onChange={(e) => {
                        changeInputCondition('employee', e.target.value, setWorkplaceItem)
                      }}>
                        <option value="" hidden>{'선택해 주세요'}</option>
                        <option value="5under">{'5명 미만'}</option>
                        <option value="5over">{'5명 이상'}</option>
                        <option value="10over">{'10명 이상'}</option>
                        <option value="20over">{'20명 이상'}</option>
                      </select>
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12" colSpan={2}>보유차량 수</td>
                    <td className="w-40" colSpan={8}>
                      <div className="d-flex align-items-center justify-content-around">
                        {vehicles && vehicles.map((item, index) => (
                          <div style={{gap: 4}} key={item.key + index} className="d-flex align-items-center">
                            <input id={item.key} className="is-untouched is-pristine av-valid form-check-input dashboard-check-abled" type="checkbox" name="vehicles" checked={vehicleItem[item.key] >= 0} onChange={(e) => {
                              if (e.target.checked) {
                                setVehicleItem({...vehicleItem, [item.key]: 0})
                              } else {
                                const {[item.key]: _, ...newObj} = vehicleItem
                                setVehicleItem(newObj)
                              }
                            }} />
                            <label htmlFor={item.key} className="mb-0">{item.text}</label>
                            <input style={{width: 50}} className='waver-input-box border-radius-0 margin-right-4' value={vehicleItem[item.key] ?? ''} disabled={!(vehicleItem[item.key] >= 0)} onChange={(e) => {
                              setVehicleItem({...vehicleItem, [item.key]: e.target.value})
                            }} />
                          </div>
                        ))}
                      </div>
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12" colSpan={2}>처리능력(kg)</td>
                    <td className="w-15" colSpan={3}>
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="처리능력(kg)을 입력하세요." value={workplaceItem.capacity || ''} onChange={(e) => {
                        changeInputCondition('capacity', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12" colSpan={2}>처리실적(ton)</td>
                    <td className="w-40" colSpan={8}>
                      <div className="d-flex align-items-center justify-content-around">
                        {performances && performances.map((item, index) => (
                          <div style={{gap: 4}} key={item.key + index} className="d-flex align-items-center">
                            <input id={item.key} className="is-untouched is-pristine av-valid form-check-input dashboard-check-abled" type="checkbox" name="performances" checked={performanceItem[item.key] >= 0} onChange={(e) => {
                              if (e.target.checked) {
                                setPerformanceItem({...performanceItem, [item.key]: 0})
                              } else {
                                const {[item.key]: _, ...newObj} = performanceItem
                                setPerformanceItem(newObj)
                              }
                            }} />
                            <label htmlFor={item.key} className="mb-0">{item.text}</label>
                            <input style={{width: 50}} className='waver-input-box border-radius-0 margin-right-4' value={performanceItem[item.key] ?? ''} disabled={!(performanceItem[item.key] >= 0)} onChange={(e) => {
                              setPerformanceItem({...performanceItem, [item.key]: e.target.value})
                            }} />
                          </div>
                        ))}
                      </div>
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12" colSpan={2}>재생원료 실적(ton)</td>
                    <td className="w-40" colSpan={8}>
                      <div className="d-flex align-items-center justify-content-around">
                        {recycles && recycles.map((item, index) => (
                          <div style={{gap: 4}} key={item.key + index} className="d-flex align-items-center">
                            <input id={item.key} className="is-untouched is-pristine av-valid form-check-input dashboard-check-abled" type="checkbox" name="recycles" checked={recycleItem[item.key] >= 0} onChange={(e) => {
                              if (e.target.checked) {
                                setRecycleItem({...recycleItem, [item.key]: 0})
                              } else {
                                const {[item.key]: _, ...newObj} = recycleItem
                                setRecycleItem(newObj)
                              }
                            }} />
                            <label htmlFor={item.key} className="mb-0">{item.text}</label>
                            <input style={{width: 50}} className='waver-input-box border-radius-0 margin-right-4' value={recycleItem[item.key] ?? ''} disabled={!(recycleItem[item.key] >= 0)} onChange={(e) => {
                              setRecycleItem({...recycleItem, [item.key]: e.target.value})
                            }} />
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12" colSpan={2}>거래처 수</td>
                    <td className="w-15" colSpan={18}>
                      <select className='waver-select-box w-100 border-radius-0' value={workplaceItem.businessPartner || ''} onChange={(e) => {
                        changeInputCondition('businessPartner', e.target.value, setWorkplaceItem)
                      }}>
                        <option value="" hidden>{'선택해 주세요'}</option>
                        {businessPartners && businessPartners.map((item, index) => (
                          <option key={item.key + index} value={item.key}>{item.text}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12" colSpan={2}>시설 보유 현황</td>
                    <td className="w-15" colSpan={18}>
                      <textarea className="waver-text-box w-100 font-size-14 border-radius-0" placeholder="보유하고 있는 시설을 입력해주세요." value={workplaceItem.facility}
                      onChange={(e)=>{
                        changeInputCondition('facility', e.target.value, setWorkplaceItem);
                      }} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-end margin-top-13">
            <button type="button" className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
              modalOpen('workplace')
            }}>사업장 정보 수정</button>
          </div>
        </div>
      </div>

      <Modal
        title={'우편번호 찾기'}
        show={modalShow.post}
        onHide={() => { modalClose('post') }}
        size="md"
        bodyChildren={
          <Post></Post>
        }
      />

      <Modal
        title={'사업장 정보 수정'}
        show={modalShow.workplace}
        onHide={() => {
          modalClose('workplace')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>사업장 정보를 수정합니다. 수정을 반영할 기존에 설정 되어<br />있는 사업장 전화번호 및 기타 정보가 변경 됩니다.</p>
            <p>정말 사업장 정보를 수정 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              changeWorkplaceInfo()
            }}>
              확인
            </button>
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
              modalClose('workplace')
            }}>
              취소
            </button>
          </div>
        }
      >
      </Modal>
    </React.Fragment>
  )
}

export default WorkplaceManagementTreatment
